module.exports = __webpack_public_path__ + "static/media/bon.d197ceca.png";